/**
 * PDP — From the Same Collection carousel (scoped, one init per section).
 */
(function () {
  'use strict';

  var initialized = new WeakSet();
  var MOBILE_MQ = '(max-width: 767.98px)';

  function trackGap(track) {
    var style = window.getComputedStyle(track);
    return parseFloat(style.columnGap || style.gap) || 0;
  }

  function isDynamicStyleCarousel(root) {
    return false;
  }

  function isNativeScrollMode(root) {
    return window.matchMedia(MOBILE_MQ).matches && isDynamicStyleCarousel(root);
  }

  function initCarousel(root) {
    if (!root || initialized.has(root)) return;
    initialized.add(root);

    var viewport = root.querySelector('.tcn-pdp-same-collection__viewport');
    var track = root.querySelector('.tcn-pdp-same-collection__track');
    var prevBtn = root.querySelector('.tcn-pdp-same-collection__nav-btn--prev');
    var nextBtn = root.querySelector('.tcn-pdp-same-collection__nav-btn--next');
    var controls = root.querySelector('.tcn-pdp-same-collection__controls');
    var items = root.querySelectorAll('.tcn-pdp-same-collection__slide');

    if (!viewport || !track || !prevBtn || !nextBtn || !items.length) return;

    var currentOffset = 0;
    var resizeTimer;

    function slideStep() {
      return items[0].offsetWidth + trackGap(track);
    }

    function totalTrackWidth() {
      var gap = trackGap(track);
      return items[0].offsetWidth * items.length + gap * Math.max(0, items.length - 1);
    }

    function maxNativeOffset() {
      return Math.max(0, viewport.scrollWidth - viewport.clientWidth);
    }

    function updateCarousel() {
      var maxOffset = Math.max(0, totalTrackWidth() - viewport.offsetWidth);
      var needsNav = maxOffset > 1;
      var nativeScroll = isNativeScrollMode(root);

      if (controls) {
        controls.hidden = !needsNav;
        controls.setAttribute('aria-hidden', !needsNav ? 'true' : 'false');
      }

      if (nativeScroll) {
        track.style.transform = '';
        prevBtn.disabled = viewport.scrollLeft <= 1;
        nextBtn.disabled = viewport.scrollLeft >= maxNativeOffset() - 1;
        return;
      }

      if (!needsNav) {
        currentOffset = 0;
        track.style.transform = 'translateX(0)';
        prevBtn.disabled = true;
        nextBtn.disabled = true;
        return;
      }

      if (currentOffset < 0) currentOffset = 0;
      if (currentOffset > maxOffset) currentOffset = maxOffset;

      track.style.transform = 'translateX(-' + currentOffset + 'px)';
      prevBtn.disabled = currentOffset === 0;
      nextBtn.disabled = currentOffset >= maxOffset;
    }

    prevBtn.addEventListener('click', function () {
      if (isNativeScrollMode(root)) {
        viewport.scrollBy({ left: -slideStep(), behavior: 'smooth' });
        return;
      }
      currentOffset -= slideStep();
      updateCarousel();
    });

    nextBtn.addEventListener('click', function () {
      if (isNativeScrollMode(root)) {
        viewport.scrollBy({ left: slideStep(), behavior: 'smooth' });
        return;
      }
      currentOffset += slideStep();
      updateCarousel();
    });

    viewport.addEventListener(
      'scroll',
      function () {
        if (!isNativeScrollMode(root)) return;
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(updateCarousel, 40);
      },
      { passive: true }
    );

    function onResize() {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        if (isNativeScrollMode(root)) {
          viewport.scrollLeft = 0;
        } else {
          currentOffset = 0;
        }
        updateCarousel();
      }, 120);
    }

    if (typeof ResizeObserver !== 'undefined') {
      var ro = new ResizeObserver(onResize);
      ro.observe(viewport);
    } else {
      window.addEventListener('resize', onResize, { passive: true });
    }

    updateCarousel();
  }

  function boot() {
    document
      .querySelectorAll(
        '[data-tcn-pdp-same-collection], [data-tcn-pdp-featured-carousel], [data-tcn-pdp-recently-viewed-carousel], [data-tcn-pdp-pair-with]'
      )
      .forEach(initCarousel);
  }

  window.TcnPdpSameCollection = {
    init: function (root) {
      if (!root) {
        boot();
        return;
      }
      initialized.delete(root);
      initCarousel(root);
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target && event.target.querySelector
      ? event.target.querySelector(
          '[data-tcn-pdp-same-collection], [data-tcn-pdp-featured-carousel], [data-tcn-pdp-recently-viewed-carousel], [data-tcn-pdp-pair-with]'
        )
      : null;
    if (root) {
      initialized.delete(root);
      initCarousel(root);
    } else {
      boot();
    }
  });
})();
